<form
  [formGroup]="stepForm"
  class="mbs-wizard_form">
  <mbs-form-group>
    <mbs-input
      [id]="'host-server'"
      [validationWhitespace]="true"
      [label]="'wizards:select_host_server' | i18next"
      (change)="resetIsValidCredentials()"
      placeholder="127.0.0.1"
      name="server"
      formControlName="server"></mbs-input>
  </mbs-form-group>

  <mbs-form-group>
    <mbs-input
      [id]="'host-login'"
      [validationWhitespace]="true"
      [label]="(isProxmox || isRestoreProxmox || ibbProxmox ? 'wizards:selectHostUserTokenId' : 'wizards:select_host_login') | i18next"
      (change)="resetIsValidCredentials()"
      name="login"
      formControlName="login"></mbs-input>
  </mbs-form-group>

  <mbs-form-group>
    <mbs-input
      autocomplete="one-time-code"
      name="Password"
      formControlName="password"
      [autocomplete]="'off'"
      [id]="'host-password'"
      [label]="'wizards:select_host_password' | i18next"
      [placeholder]="'wizards:password_placeholder' | i18next"
      [type]="passwordInputType"
      (blur)="passwordBlurHandler($event)"
      (buttonClick)="changeTypePassword()"
      (focus)="passwordFocusHandler($event)"
      (change)="resetIsValidCredentials()"
      [appendButtons]="[
        {
          icon: passwordInputType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash',
          id: 'changeTypePasswordOnEncryptionOptions',
          disabled: stepForm.get('password')?.value === InitialValue?.password || stepForm.get('password')?.disabled,
          type: 'secondary'
        }
      ]"
      [validationWhitespace]="true">
    </mbs-input>
  </mbs-form-group>

  @if (ibbOrProxmoxOrVMware && hostsList?.length) {
    <mbs-select
      formControlName="host"
      (change)="resetIsValidCredentials()"
      [attr.data-e2e]="elementSelectors.name.hostSelect"
      [appendTo]="'.modal-content'"
      [showRequiredMark]="false"
      [clearable]="false"
      [hideSelected]="false"
      [items]="hostsList"
      [id]="'restore-host'"
      [label]="'wizards:selectHost' | i18next"
      [placeholder]="'wizards:selectHostPlaceholder' | i18next"
      [searchable]="false"></mbs-select>
  }

  <mbs-alert
    *ngIf="isRestoreVMWareOrProxmox && hostsList?.length && !value?.host"
    class="mb-0 mt-3"
    [attr.data-e2e]="elementSelectors.name.hostAlert"
    [type]="mbsPopupType.warning"
    [icon]="true">
    {{ (isRestoreProxmox ? 'wizards:hostAlertProxmox' : 'wizards:hostAlert') | i18next }}
  </mbs-alert>
</form>
